<template>
  <div class="main-content">
    <breadcrumb :nameSection="nameSection" :listRoutes="listRoutes"></breadcrumb>
    <div
      style="display: grid; grid-template-columns: 4fr 1fr; gap: 1rem; align-items: start"
    >
      <div class="form-content">
        <div class="form-content-title">
          <div class="form-content-title-block form-title">
            <div class="form-title-block form-title-principal">
              <span>Warehouse</span>
            </div>
          </div>
        </div>

        <div class="table-paquete">
          <data-table
            :columns="columns"
            :sortKey="sortKey"
            :sortOrders="sortOrders"
            @sort="sortBy"
            v-if="is_loading == false"
          >
            <section class="u-table p-4">
              <div class="u-row-wr u-row--header">
                <h4 class="u-row__title">Producto</h4>
                <h4 class="u-row__title">Warehouse</h4>
                <h4 class="u-row__title">Acciones</h4>
              </div>
              <div class="u-row-wr" v-for="data in warehouseorder" :key="data">
                <div>
                  <!-- Boton de nuevo paquete -->
                  <!-- <button v-if="!isOrder" @click="openModal('modal-orden')" class="btn-paquete" type="button">
                  <i class="fas fa-plus"></i>
                  <span>Asociar orden</span>
                </button> -->
                  <!-- Card de producto -->
                  <article class="card-product">
                    <a href="#" target="_blank">
                      <img
                        :src="data.attributes.product_image_url"
                        class="card-product__img"
                        v-if="data.attributes.product_image_url"
                      />
                      <img
                        v-else
                        src="https://pngimage.net/wp-content/uploads/2018/06/producto-icono-png-3.png"
                        class="card-product__img"
                      />
                    </a>
                    <div class="card-product__text">
                      <h3 class="card-product__title">
                        <span>{{ data.attributes.product_info }}</span>
                        <a
                          v-if="data.attributes.reference_link"
                          :href="data.attributes.reference_link"
                          target="_Blank"
                        >
                          <i class="fas fa-link"></i>
                        </a>
                      </h3>
                      <div class="card-product__info">
                        <p class="">
                          <span class="">Nombres:</span>
                          {{ data.attributes.client.attributes.profile.attributes.name }}
                          <br />
                          {{
                            data.attributes.client.attributes.profile.attributes.surnames
                          }}
                        </p>
                        <p class="">
                          <span class="">Código del cliente:</span>
                          {{
                            data.attributes.client.attributes.profile.attributes.userable
                              .client_code
                          }}
                        </p>
                        <p class="">
                          <span class="">Código de Tracking:</span>
                          {{ data.attributes.system_tracking_number }}
                        </p>
                        <p class="">
                          <span class="">Viaje desde:</span>
                          {{ data.attributes.origin.attributes.name }}
                        </p>
                        <p class="">
                          <span class="">Viaje a:</span>
                          {{ data.attributes.destination.attributes.name }}
                        </p>
                        <p class="">
                          <span class="">Número de orden:</span>
                          #{{ data.id }}
                        </p>
                      </div>
                    </div>
                  </article>
                </div>
                <div style="max-width: 38vw">
                  <!-- Boton de nuevo paquete -->
                  <!-- <button v-if="!isWr" class="btn-paquete" type="button" @click="openModal('modal-wr')">
                  <i class="fas fa-plus"></i>
                  <span>Nuevo paquete</span>
                </button> -->
                  <!-- Cards de warehouse -->
                  <template>
                    <vue-glide :perView="2">
                      <vue-glide-slide
                        v-for="wr in data.attributes.warehouse_packages"
                        :key="wr"
                      >
                        <article class="card-product">
                          <div class="card-product__text">
                            <h3 class="card-product__title">
                              <span
                                >#{{ wr.attributes.code }}-
                                <a
                                  @click.prevent="liberarWR(wr.attributes.code)"
                                  style="cursor: pointer; color: blue"
                                >
                                  Liberar
                                </a></span
                              >
                              <a href="#">
                                <i class="fas fa-link"></i>
                              </a>
                            </h3>
                            <div class="card-product__info">
                              <p class="">
                                <span class="">Remitente:</span>
                                {{
                                  wr.attributes.remitter
                                    ? wr.attributes.remitter
                                    : "Sin remitente"
                                }}
                              </p>
                              <p class="">
                                <span class="">Consignatario:</span>
                                {{ wr.attributes.consignee }}
                              </p>
                              <p class="">
                                <span class="">Remitente:</span>
                                {{ wr.attributes.remitter }}
                              </p>
                              <p class="">
                                <span class="">Carrier:</span>
                                {{ wr.attributes.carrier }}
                              </p>

                              <p class="">
                                <span class="">Peso:</span>
                                {{ wr.attributes.weight }}
                                <b>
                                  {{ wr.attributes.weight_unit.attributes.key_name }}</b
                                >
                              </p>
                              <p class="">
                                <span class="">Comentario:</span>
                                {{ wr.attributes.comment }}
                              </p>
                              <a
                                v-if="wr.attributes.images"
                                href="#"
                                style="color: #1ea9e4; font-weight: 600"
                                @click.prevent="
                                  openModal('modal-fotos', null, wr.attributes.images)
                                "
                              >
                                <i class="fas fa-link mr-2"></i>
                                Ver fotos
                              </a>
                            </div>
                          </div>
                        </article>
                      </vue-glide-slide>

                      <template slot="control">
                        <button data-glide-dir="<" class="slider__btn slider__btn--prev">
                          <i class="fas fa-arrow-left"></i>
                        </button>
                        <button data-glide-dir=">" class="slider__btn slider__btn--next">
                          <i class="fas fa-arrow-right"></i>
                        </button>
                      </template>
                    </vue-glide>
                  </template>
                </div>
                <div>
                  <button
                    @click.prevent="openModal('modal-wr', data.id)"
                    class="btn btn-primary mb-3 d-block mx-auto"
                    :disabled="data.attributes.warehouse_flag == 1"
                  >
                    Registrar ingreso
                  </button>
                  <button
                    v-if="data.attributes.warehouse_packages.length !== 0"
                    @click.prevent="limitchangePaquete(data.id)"
                    class="btn d-block mx-auto"
                    :class="
                      data.attributes.warehouse_flag == 0 ? 'btn-primary' : 'btn-success'
                    "
                  >
                    <i
                      v-if="data.attributes.warehouse_flag !== 0"
                      class="fas fa-check pr-2 pt-1"
                    ></i>
                    {{
                      data.attributes.warehouse_flag == 0
                        ? "Items incompletos"
                        : "Items completos"
                    }}
                  </button>
                </div>
              </div>
            </section>
          </data-table>
        </div>
      </div>
      <div class="wr-slider-vertical">
        <div
          class="form-title-block"
          v-if="$store.state.user.attributes.permissions_keys.includes(8)"
        >
          <button @click="openModal('modal-wr')" class="btn btn-primary form-control">
            <i class="fas fa-plus"></i>
            Nuevo paquete
          </button>
        </div>
        <article class="card-product" v-for="data in wrSinAsignar" :key="data">
      
          <div class="card-product__text">
            <h3 class="card-product__title">
              <span>{{ data.attributes.code }}</span> -
              <span style="color: red; cursor: grab" @click.prevent="deleteWR(data)"
                >Eliminar</span
              >
              <a @click.prevent="copyCodeWr(data.attributes.code)">
                <i class="fas fa-link"></i>
              </a>
            </h3>
            <div class="card-product__info">
              <p class="">
                <span class="">Remitente:</span>
                {{
                  data.attributes.remitter ? data.attributes.remitter : "Sin remitente"
                }}
              </p>
              <p class="">
                <span class="">Consignatario:</span>
                {{ data.attributes.consignee }}
              </p>
              <p class="">
                <span class="">Remitente:</span>
                {{ data.attributes.remitter }}
              </p>
              <p class="">
                <span class="">Carrier:</span>
                {{ data.attributes.carrier }}
              </p>
              <p class="">
                <span class="">Peso:</span>
                {{ data.attributes.weight }}
                <b> {{ data.attributes.weight_unit.attributes.key_name }}</b>
              </p>
              <p class="">
                <span class="">Comentario:</span>
                {{ data.attributes.comment }}
              </p>
              <a
                v-if="data.attributes.images"
                href="#"
                style="color: #1ea9e4; font-weight: 600"
                @click.prevent="openModal('modal-fotos', null, data.attributes.images)"
              >
                <i class="fas fa-link mr-2"></i>
                Ver fotos
              </a>
            </div>
          </div>
        </article>
      </div>
    </div>
    <pagination
      :pagination="pagination"
      @changePagination="getPurchaseOrders"
      v-if="is_loading == false"
    ></pagination>

    <dialog id="modal-fotos">
      <article class="u-modal">
        <form class="u-modal-content" style="max-width: 70vw; width: 70vw">
          <div class="form-block-text d-flex justify-content-between">
            <span>Fotos del producto</span>
            <span style="cursor: pointer" @click="closeModal('modal-fotos')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>
          <div
            class="gallery"
            style="display: grid; grid-template-columns: 1fr 1fr 1fr; gap: 1rem"
          >
            <img
              v-for="image in wrFotos"
              :key="image"
              class="product-image"
              :src="image.url"
              alt=""
            />
          </div>
        </form>
      </article>
    </dialog>
    <!-- Modal Warehouse -->
    <dialog id="modal-wr">
      <article class="u-modal">
        <form @submit.prevent="createPaquete" class="u-modal-content">
          <div class="form-block-text d-flex justify-content-between">
            <span>Datos del paquete</span>
            <span style="cursor: pointer" @click="closeModal('modal-wr')">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                style="fill: rgba(0, 0, 0, 1); transform: ; msfilter: "
              >
                <path
                  d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"
                ></path>
              </svg>
            </span>
          </div>

          <div class="form-group">
            <label>Remitente :</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.remitter"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="form-group">
            <label>Destinatario :(Consignatario)</label>
            <div class="input-group">
              <input
                type="text"
                v-model="formCreate.consignee"
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Carrier :</label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.carrier"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Tracking :</label>
              <div class="input-group">
                <input
                  type="text"
                  v-model="formCreate.tracking"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="form-group col-6 pl-0">
              <label>Peso :</label>
              <div class="input-group">
                <input
                  type="number"
                  v-model="formCreate.weight"
                  name=""
                  class="form-control input"
                  required
                />
              </div>
            </div>
            <div class="form-group col-6 pr-0">
              <label>Unidad de peso :</label>
              <div class="input-group">
                <select class="form-control" v-model="formCreate.unidad" required>
                  <option selected="selected" :value="12">Kg</option>
                  <option selected="selected" :value="2">Lb</option>
                  <option selected="selected" :value="22">Oz</option>
                </select>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label>Comentario :</label>
            <div class="input-group">
              <textarea
                v-model="formCreate.comment"
                type="text"
                name=""
                class="form-control input"
                rows="6"
                required
              ></textarea>
            </div>
          </div>
          <div class="form-group">
            <label>Fotos del paquete :</label>
            <div class="input-group">
              <input
                type="file"
                @change="handleFileInput"
                multiple
                name=""
                class="form-control input"
                required
              />
            </div>
          </div>
          <button type="submit" class="btn btn-primary mx-auto d-block mt-4">
            Registrar ingreso
          </button>
        </form>
      </article>
    </dialog>
  </div>
</template>
<style>
.u-table {
}

.u-row-wr {
  display: grid;
  align-items: start;
  grid-template-columns: 2fr 3fr 1fr;
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.u-row--header {
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #ccc;
}

.u-row__title {
  font-size: 14px;
  font-weight: 700;
  opacity: 0.65;
}

.card-product {
  display: flex;
  align-items: flex-start;
  gap: 1.25rem;
  padding: 1.25rem 1rem;
  border-radius: 8px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.25);
  color: #4f5665;
  margin: 0.25rem;
}

.card-product__img {
  display: block;
  border-radius: 50%;
  object-fit: cover;
  width: 3rem;
  height: 3rem;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.5);
}

.card-product__text {
  width: 100%;
}

.card-product__title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 600;
  font-size: 1rem;
  margin-bottom: 1.25rem;
  gap: 1rem;
}

.card-product__info {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0.75rem;
}

.card-product__info p {
  font-size: 14px;
  margin: 0;
}

.card-product__info p span:nth-of-type(1) {
  display: block;
  font-weight: 600;
  margin-bottom: 0.25rem;
  background-color: transparent;
}

.btn-paquete {
  cursor: pointer;
  display: grid;
  gap: 1rem;
  border: 3px solid rgba(30, 169, 228, 0.25);
  background-color: rgba(30, 169, 228, 0.15);
  border-radius: 12px;
  padding: 1.5rem 2rem;
  width: max-content;
  margin: 0 auto;
  text-align: center;
  color: #1990c4;
  font-size: 18px;
  font-weight: 600;
}

.slider__btn {
  position: absolute;
  top: calc(50% - 24px);
  cursor: pointer;
  font-size: 24px;
  border: none;
  background-color: transparent;
}

.slider__btn--prev {
  left: -1.5rem;
}

.slider__btn--next {
  right: -1.5rem;
}

.product-image {
  display: block;
  margin: 0 auto;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
<script>
import { Glide, GlideSlide } from "vue-glide-js";
import breadcrumb from "@/components/prefab/structures/breadcrumb.vue";
import DataTable from "./DataTable.vue";
import Pagination from "./Pagination.vue";
import axios from "axios";
export default {
  components: {
    DataTable,
    Pagination,
    breadcrumb,
    [Glide.name]: Glide,
    [GlideSlide.name]: GlideSlide,
  },
  data() {
    // eslint-disable-next-line no-unused-vars
    let statusGroupArray = {
      1: "Todos",
      10: "Inicializando",
      20: "En proceso",
      30: "Cancelado",
      40: "Finalizado",
    };
    // eslint-disable-next-line no-unused-vars
    let statusArray = {
      1: "En evaluación",
      2: "Esperando confirmación de evaluación",
      3: "Completando información adicional",
      4: "En camino a origen",
      5: "En origen y evaluación de recepción",
      6: "Listo para embarcar",
      7: "En embarque",
      8: "Entregado correctamente",
      9: "",
      10: "Cancelado",
    };
    // eslint-disable-next-line no-unused-vars
    let cancelledReasonFlagArray = {
      1: "Por decisión propia",
      2: "Por incidencia de tracking",
    };
    let sortOrders = {};
    let columns = [
      { label: "Producto", name: "product", visible: false },
      { label: "Consignatario", name: "consignatario", visible: false },
      { label: "Acciones", name: "acciones", visible: false },
    ];

    columns.forEach((column) => {
      sortOrders[column.name] = -1;
    });
    return {
      wrFotos: [],
      //almacena todos los paquetes
      warehouseorder: null,
      //Formulario para crear un paquete
      formCreate: {
        purchase_order_id: null,
        consignee: null,
        remitter: null,
        carrier: null,
        tracking: null,
        comment: null,
        unidad: 12,
        weight: null,
        images: [],
      },
      valorRadioButton: true,
      purchaseOrders: null,
      columns,
      statusGroupArray,
      statusArray,
      cancelledReasonFlagArray,
      sortKey: "promised_delivery_date",
      sortOrders: sortOrders,
      filterKey: "",
      expanded: false,
      tableData: {
        statusFlag: {
          todos: true,
          activos: true,
          cancelados: true,
        }, // 0: Inicializando, 1: En proceso, 2: Cancelado, 3: Finalizado
        draw: 0,
        length: 10,
        status: "",
        orderBy: "promised_delivery_date",
        dir: "desc",
        filterBy: "all",
        page: 1,
        filterValue: null, // no hay ningun valor por el cual filtrar
        order_type: 5, // órdenes de Grabr y no Grabr
        store: "all",
      },
      pagination: {
        lastPage: "",
        currentPage: "",
        total: "",
        lastPageUrl: "",
        nextPageUrl: "",
        prevPageUrl: "",
        from: "",
        to: "",
      },
      grabr: {
        id: "1",
      },
      is_loading: true,
      nameSection: "Warehouse",
      listRoutes: [{ nameRoute: "Warehouse", titleRoute: "Warehouse" }],
      wrSinAsignar: null,
    };
  },
  created() {
    this.getPurchaseOrders();
    this.listWrSinOrden();
  },
  methods: {
    deleteWR(wr) {
      var answer = window.confirm(
        "Confirmar para eliminar WR con el código:" + wr.attributes.code
      );

      if (answer) {
        let url = process.env.API_URL + "/api/warehouse/delete/" + wr.id;
        axios
          .delete(url)
          .then(() => {
            window.location.reload();
          })
          .catch(() => {
            alert("Error al eliminar el WR ");
          });
      }
    },
    liberarWR(code) {
      let url = process.env.API_URL + "/api/warehouse/unnasignByCode/" + code;
      axios
        .get(url)
        .then(() => {
          window.location.reload();
        })
        .catch(() => {
          alert("Error al liberar el WR ");
        });
    },
    copyCodeWr(idCode) {
      navigator.clipboard
        .writeText(idCode)
        .then(() => {
          alert("Código de WR copiado");
        })
        .catch((error) => console.log(error));
    },
    listWrSinOrden() {
      let url = process.env.API_URL + "/api/warehouse/list-packages";
      axios
        .get(url)
        .then((response) => {
          this.wrSinAsignar = response.data.data;
        })
        .catch(() => {
          alert("Error al cambiar el WR sin Asignar");
        });
    },
    limitchangePaquete(idOrder) {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/changeWarehouseStatus/" + idOrder;
      axios
        .get(url)
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al cambiar el estado");
          this.is_loading = false;
        });
    },
    //dev marco -> guardar imagees del apquete//
    handleFileInput(event) {
      const files = event.target.files;
      const images = [];

      for (let i = 0; i < files.length; i++) {
        const file = files[i];

        if (!file.type.match("image.*")) {
          continue;
        }
        const reader = new FileReader();

        reader.onload = (function (file) {
          return function (event) {
            images.push(event.target.result);
          };
        })(file);
        reader.readAsDataURL(file);
        this.formCreate.images = images;
      }
    },

    //dev marco ->create paquete//
    createPaquete() {
      this.is_loading = true;
      let url = process.env.API_URL + "/api/warehouse/save-package";
      axios
        .post(url, {
          operator_id: 398,
          purchase_order_id: this.formCreate.purchase_order_id,
          consignee: this.formCreate.consignee,
          remitter: this.formCreate.remitter,
          carrier: this.formCreate.carrier,
          tracking: this.formCreate.tracking,
          comment: this.formCreate.comment,
          weight_unit_id: this.formCreate.unidad,
          weight: this.formCreate.weight,
          images: this.formCreate.images,
        })
        .then(() => {
          location.reload();
        })
        .catch(() => {
          alert("Error al crear el paquete");
          this.is_loading = false;
        });
    },
    getStore(link) {
      if (link !== null) {
        var separation1 = link.split(".", 2);

        return separation1[1];
      }
      return "Sin store";
    },
    cambiarEstado() {
      this.valorRadioButton = false;
    },

    toGrabrDetail(code) {
      console.log("hacia el detalle de grabr");
      let linkToGrabr = "https://grabr.io/es/grabs/" + code;
      window.location = linkToGrabr;
    },
    showCheckboxes() {
      var checkboxes = document.getElementById("checkboxes");
      if (!this.expanded) {
        checkboxes.style.display = "block";
        this.expanded = true;
      } else {
        checkboxes.style.display = "none";
        this.expanded = false;
      }
      window.addEventListener("click", function (e) {
        if (document.getElementById("checkboxes2").contains(e.target)) {
          checkboxes.style.display = "block";
        } else {
          checkboxes.style.display = "none";
        }
      });
    },
    getPurchaseOrders(page, url = "", fromPagination = false) {
      // 1: Ver todas las órdenes de compra, 2: Ver todas las órdenes de compra por operador, 3: Ver todas las órdenes de compra por cliente
      console.log("Cargando todas las PurchasOrders");
      this.is_loading = true;
      this.tableData.page = page;
      this.tableData.draw++;
      url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      this.tableData.status = this.statusComputed;
      axios
        .get(url, { params: fromPagination ? {} : this.tableData })
        .then((response) => {
          let data = response.data;
          console.log(data);
          if (this.tableData.draw === data.meta.draw || fromPagination) {
            console.log("there are sync or if from pagination");
            this.warehouseorder = data.data;
            this.configPagination(data);
            this.is_loading = false;
          } else {
            console.log("out of sync");
            this.is_loading = false;
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.warehouseorder = null;
          this.is_loading = false;
          return;
        });
    },
    getPurchaseOrdersByPage(page = 1) {
      // 1: Ver todas las órdenes de compra,
      // 2: Ver todas las órdenes de compra por operador
      // 3: Ver todas las órdenes de compra por cliente
      console.log("getPurchaseOrders");
      this.is_loading = true;
      this.tableData.draw++;
      this.tableData.page = page;

      let permissions = this.$store.state.user.attributes.permissions_keys;
      let url = "";
      if (permissions.includes(1)) {
        url = process.env.API_URL + "/api/purchaseOrder/list-orders-all";
      } else if (permissions.includes(2)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-operator";
      } else if (permissions.includes(3)) {
        url =
          process.env.API_URL +
          "/api/purchaseOrder/" +
          this.$store.state.user.id +
          "/list-orders-by-client";
      } else {
        // alert('El usuario no tiene permisos para ver órdenes de compra')
        return;
      }
      this.tableData.status = this.statusComputed;

      // eslint-disable-next-line no-unreachable
      axios
        .get(url, { params: this.tableData })
        .then((response) => {
          let data = response.data;

          if (this.tableData.draw === data.meta.draw) {
            console.log("RESPONSE:");

            console.log("there are sync");
            console.log("Table data : ");
            console.log(this.tableData);
            console.log(data);

            console.log("=======================");

            this.purchaseOrders = data.data;
            this.configPagination(data);
            this.is_loading = false;
            console.log("FIN RESPONSE");
          } else {
            console.log("ERROR:");

            console.log("out of sync");

            console.log(this.tableData);
            this.is_loading = false;
            console.log("FIN ERROR");
          }
        })
        .catch((errors) => {
          console.log(errors);
          console.log(errors.response);
          console.log("error");
          // alert('No se obtuvieron resultados')
          this.purchaseOrders = null;
          this.is_loading = false;
          return;
        });
    },
    cleanInput() {
      this.tableData.filterValue = "";
      if (this.tableData.filterBy == "all") {
        this.getPurchaseOrders();
      }
    },
    configPagination(data) {
      this.pagination.lastPage = data.meta.last_page;
      this.pagination.currentPage = data.meta.current_page;
      this.pagination.total = data.meta.total;
      this.pagination.lastPageUrl = data.links.last;
      this.pagination.nextPageUrl = data.links.next;
      this.pagination.prevPageUrl = data.links.prev;
      this.pagination.from = data.meta.from;
      this.pagination.to = data.meta.to;
      this.pagination.perPage = this.tableData.length;
    },
    sortBy(key) {
      console.log("entro al sort", key);
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
      this.tableData.orderBy = this.sortKey;
      /* this.tableData.orderBy = this.getIndex(this.columns, 'name', key) */
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir,
        this.sortOrders[key]
      );
      this.tableData.dir = this.sortOrders[key] === 1 ? "asc" : "desc";
      console.log(
        "tableData.orderBy",
        this.tableData.orderBy,
        "tableData.dir",
        this.tableData.dir
      );
      this.getPurchaseOrders();
      console.log("paso la peticion api");
    },
    getIndex(array, key, value) {
      return array.findIndex((i) => i[key] === value);
    },
    hideModal() {
      this.$refs.formmodal.hide();
    },
    // toDetailView(data) {
    //   console.log(data)
    //   this.$router.push({
    //     name: 'show-purchase-order',
    //     params: { id: data.id, orderData: data }
    //   })
    // },
    openModal(id, idorder, fotos) {
      if (id === "modal-fotos") {
        this.wrFotos = fotos;
      } else {
        this.wrFotos = [];
      }
      const modal = document.getElementById(id);
      this.formCreate.purchase_order_id = idorder ? idorder : null;
      modal.showModal();
    },
    closeModal(id) {
      if (id === "modal-fotos") {
        this.wrFotos = [];
      }
      const modal = document.getElementById(id);
      modal.close();
    },
  },
  computed: {
    diasRestantes() {
      let fechaEntrega = this.purchaseOrders;

      fechaEntrega.forEach((data) => {
        let fechaEntrega = data.attributes.promised_delivery_date;
        let fecha = new Date();
        let fechaini = new Date(fechaEntrega);
        let diff = fechaini.getTime() - fecha.getTime();
        let diasRestantes = Math.round(diff / (1000 * 60 * 60 * 24));
        data.resultado = diasRestantes;
      });

      return fechaEntrega;
    },
    filterColumns() {
      // let activeFilterColumns = [
      //   "product_info",
      //   "destination",
      //   "order_code",
      //   "tracking_number",
      //   "grabr_code",
      //   "client_name",
      //   "client_dni",
      //   "client_grabr_id",
      //   "id",
      // ];

      let activeFilterColumns = [
        "product_info",
        "referent link",
        "order_code",
        "client_grabr_id",
        "destination",
        "tracking_number",
      ];
      return this.columns.filter((i) => activeFilterColumns.indexOf(i.name) > -1);
    },
    statusComputed() {
      console.log("statuscomputed");
      return JSON.stringify([
        this.tableData.statusFlag.todos,
        this.tableData.statusFlag.activos,
        this.tableData.statusFlag.cancelados,
      ]);
    },
  },
};
</script>



// WEBPACK FOOTER //
// WarehouseTable.vue?26a32fe9